var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper"},[(_vm.logoUrl)?_c('object',{attrs:{"data":_vm.logoUrl,"type":_vm.logoFileType}}):_c('div',{staticClass:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }